





















import Vue from 'vue';
import Component from 'vue-class-component';
import { IConfirm } from '@/entities/confirm.interface';
import * as types from '@/store/types';

// TODO add keyboard events for esc/enter, add focus for confirm btn
@Component({})
export default class ConfirmContainer extends Vue {
    public loading: boolean = false;

    get confirm(): IConfirm {
        return this.$store.state.confirm.confirm;
    }

    get cancelVisible(): boolean {
        if (this.confirm.cancelBtn === false) {
            return false;
        }
        return true;
    }

    get confirmBtnLabel(): string {
        return 'Confirm';
    }

    get visible(): boolean {
        return !!this.confirm;
    }

    get heading() {
        return this.confirm.heading;
    }

    public cancel() {
        if (this.loading) {
            return;
        }

        this.close();
    }

    public submit() {
        this.loading = true;
        this.confirm.afterFn(() => {
            this.loading = false;
            this.close();
        });
    }

    public overlayClick($event) {
        if (
            $event.target.classList.contains('overlay_class_simulate_outside')
        ) {
            this.cancel();
        }
    }

    public close() {
        this.$store.dispatch(types.CLOSE_CONFIRM);
    }
}
